module.exports = __webpack_public_path__ + "static/media/branding-img1.9cfe7c88.jpg";